import script from "./FavoSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoSelect.vue?vue&type=script&setup=true&lang=js"

import "./FavoSelect.vue?vue&type=style&index=0&id=6f797222&lang=less&scoped=true"

import exportComponent from "D:\\aj项目\\code\\清洁能源中文预登记\\ceec_-visitor_-cn\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f797222"]])

export default __exports__